import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Toolbar, Typography, Paper } from "@material-ui/core";
import clsx from "clsx";
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "white",
    padding: theme.spacing(2),
    // paddingLeft: theme.spacing(2),
    // paddingRight: theme.spacing(1),
    // border: "1px solid gray",
    borderRadius: 0,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
}));

const TableTitle = ({ title }) => {
  const classes = useStyles();

  return (
    <Paper className={clsx(classes.root)} variant="outlined">
      <Typography
        className={classes.title}
        color="inherit"
        variant="h6"
        component="div"
      >
        {title}
      </Typography>
    </Paper>
  );
};
export default TableTitle;
